import { apiNames, get, post } from '@general/api/shared';

export const fetchFunds = () => get(apiNames.TRANSACTION, 'funds');
// export const fetchFoundationDonationSubscription = ({ memberId, fundCode, amount }) =>
//     post({ apiName: apiNames.TRANSACTION, endpoint: `billing/${memberId}/recurring-donation/${fundCode}/${amount}` });

export const insertFoundationDonation = values =>
    post({ apiName: apiNames.TRANSACTION, endpoint: `foundation-donations`, data: values });

export const insertFoundationDonationCart = (cartID, values) =>
    post({ apiName: apiNames.TRANSACTION, endpoint: `carts/${cartID}/checkout`, data: values });
